// extracted by mini-css-extract-plugin
export default {"ContractorCard":"ContractorCard_ContractorCard__dg3K4","name":"ContractorCard_name__WzbjB","buttonInner":"ContractorCard_buttonInner__EPtxM"};